import { render } from "./supplier-list.vue?vue&type=template&id=5e127f74"
import script from "./supplier-list.vue?vue&type=script&lang=js"
export * from "./supplier-list.vue?vue&type=script&lang=js"

import "./supplier-list.vue?vue&type=style&index=0&id=5e127f74&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__